module.exports = __webpack_public_path__ + "static/media/projectActive.b13b8a9d.svg";